export const getCategorySettingsSuggestions = payload => {
  return {
    type: "FETCH_CATEGORY_SETTINGS_SUGGESTIONS",
    payload
  };
};

export const setCategorySettings = items => {
  return {
    type: "SET_CATEGORY_SETTINGS_SUGGESTIONS",
    items
  };
};

export const getCategoriesSettings = payload => {
  return {
    type: "FETCH_CATEGORIES_SETTINGS",
    payload
  };
};

export const getSuperCategoriesSuggestions = payload => {
  return {
    type: "FETCH_SUPER_CATEGORIE_LIST",
    payload
  };
};

export const setCategoriesSettings = items => {
  return {
    type: "SET_CATEGORIES_SETTINGS",
    items
  };
};

export const initCategoriesSettings = () => {
  return {
    type: "INIT_CATEGORIES_SETTINGS"
  };
};

export const setModifiedCategories = modified => {
  return {
    type: "SET_MODIFIED_CATEGORIES",
    modified
  };
};

export const setStandardCategories = standard => {
  return {
    type: "SET_STANDARD_CATEGORIES",
    standard
  };
};

export const setCreatedCategories = items => {
  return {
    type: "SET_CREATED_CATEGORIES",
    items
  };
};

export const setLabelsForm = labelsForm => {
  return {
    type: "SET_LABELS_FORM",
    labelsForm
  };
};

export const updateCategoriesSettingsState = resp => ({
  type: "UPDATE_CATEGORIES_SETTINGS_STATE",
  payload: resp
});

export const updateCategorySettings = resp => ({
  type: "UPDATE_CATEGORY_SETTINGS",
  payload: resp
});

export const saveCategorySettings = resp => ({
  type: "SAVE_CATEGORY_SETTINGS",
  payload: resp
});

export const deleteCategorySettings = resp => ({
  type: "DELETE_CATEGORY_SETTINGS",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/category.js